// src/components/CustomerFlow/Steps/FinalStep.js

import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { safeLocalStorage } from '../../../utils/safeLocalStorage';

const FinalStep = ({ onComplete }) => {
  const hasCompleted = useRef(false);

  useEffect(() => {
    if (!hasCompleted.current) {
      cleanupStorage();
      hasCompleted.current = true;
    }
  }, []);

  /**
   * Limpia todos los datos del storage relacionados con el token temporal y el flujo
   * Usa prefijo temp_ para no afectar la sesión del vendedor si está usando la misma ventana
   */
  const cleanupStorage = () => {
    // Limpiar tokens y datos del flujo
    safeLocalStorage.removeItem('temp_authToken');
    safeLocalStorage.removeItem('temp_tokenScope');
    safeLocalStorage.removeItem('temp_tokenType');
    safeLocalStorage.removeItem('temp_tokenSaleId');
    safeLocalStorage.removeItem('temp_tokenCustomerId');
    safeLocalStorage.removeItem('temp_tokenPurchaseRequestId');
    safeLocalStorage.removeItem('temp_tokenBranchId');
    safeLocalStorage.removeItem('temp_tokenLastValidation');
    
    // Limpiar datos de la tarjeta
    safeLocalStorage.removeItem('temp_card_last_four');
    safeLocalStorage.removeItem('temp_card_brand_name');
  };

  return (
    <div className="final-step bg-white p-4 rounded-3 text-center">
      <div className="mb-4">
        <FontAwesomeIcon icon={faCheck} className="text-success" style={{ fontSize: '4rem' }} />
      </div>
      <h3 className="text-success mb-3">¡Compra confirmada!</h3>
      <p className="text-muted">
      Tu compra fue procesada exitosamente. Consultá a tu vendedor para más información.
      </p>
      <p className="text-muted">
        Ya podés cerrar esta página.
      </p>
    </div>
  );
};

export default FinalStep;
